import { z } from "zod";

export const EventFxRatesSchema = z.object({
  fxUsdToLak: z.number().int().positive().nullable(),
  fxThbToLak: z.number().int().positive().nullable(),
  fxRateNote: z.string().trim().max(500).nullable(),
  fxRateUpdatedAt: z.coerce.date().nullable(),
  fxRateUpdatedBy: z.string().nullable(),
});

export type EventFxRatesDTO = z.infer<typeof EventFxRatesSchema>;

export const UpdateEventFxRatesSchema = z
  .object({
    fxUsdToLak: z.number().int().positive().nullable().optional(),
    fxThbToLak: z.number().int().positive().nullable().optional(),
    fxRateNote: z.string().trim().max(500).nullable().optional(),
  })
  .refine(
    (value) =>
      value.fxUsdToLak !== undefined ||
      value.fxThbToLak !== undefined ||
      value.fxRateNote !== undefined,
    { message: "ຕ້ອງລະບຸຢ່າງໜ້ອຍໜຶ່ງຟິລດ໌" },
  );

export type UpdateEventFxRatesDTO = z.infer<typeof UpdateEventFxRatesSchema>;
